import { render, staticRenderFns } from "./BlacklistDetail.vue?vue&type=template&id=6222e925&scoped=true&"
import script from "./BlacklistDetail.vue?vue&type=script&lang=js&"
export * from "./BlacklistDetail.vue?vue&type=script&lang=js&"
import style0 from "./BlacklistDetail.vue?vue&type=style&index=0&id=6222e925&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6222e925",
  null
  
)

export default component.exports